/*
 * Hero "Parallax": Tiefenbewegung beim Scrollen.
 * Jede Ebene (data-parallax-ebene) sinkt um einen Anteil des gescrollten Wegs nach
 * unten und bleibt so hinter dem Seitenlauf zurueck: hinten am meisten, vorn kaum.
 * Die Anteile stehen als --faktor im Stylesheet (theme-build/teile/parallax.css);
 * es sind die Werte der Osmo-Vorlage (GSAP ScrollTrigger), auf Anteile des
 * gescrollten Wegs umgerechnet.
 *
 * Wer bewegt:
 * - Kann der Browser Scroll-Animationen in CSS, bewegt er die Ebenen selbst
 *   (parallax.css). Das laeuft dort, wo auch gescrollt wird, und bleibt auch auf
 *   dem iPhone ruhig. Dieses Skript misst dann nur die Hoehe der Kopfzeile.
 * - Sonst fuehrt dieses Skript nach, aber nur mit Maus oder Trackpad. Auf
 *   Touch-Geraeten kaeme die Bewegung immer ein Bild zu spaet und die Ebenen
 *   zitterten; dort steht das Foto still.
 * Die Bewegung ist AN den Scroll gebunden (kein Ausloesen, kein Nachlaufen) und
 * schreibt nur transform. Bezugskante ist die Unterkante der klebenden Kopfzeile:
 * ab dort sieht man das Foto. Ohne dieses Skript steht das Bild still und ist
 * vollstaendig.
 */
(function () {
  'use strict';

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
  var touch = window.matchMedia('(hover: none) and (pointer: coarse)');
  /* dieselbe Bedingung wie das @supports in parallax.css */
  var cssScroll = !!(
    window.CSS &&
    CSS.supports &&
    CSS.supports('animation-timeline: view()') &&
    CSS.supports('animation-range: exit-crossing 0% exit-crossing 100%')
  );
  var aktiv = [];

  /* Hoehe der klebenden Kopfzeile; scrollt sie mit der Seite, zaehlt sie nicht (0) */
  function kopfHoehe() {
    var kopf = document.querySelector('.shopify-section-group-header-group');
    if (!kopf || window.getComputedStyle(kopf).position !== 'sticky') return 0;
    return kopf.getBoundingClientRect().height;
  }

  function einrichten(sektion) {
    if (sektion.hasAttribute('data-parallax-bereit')) return;
    sektion.setAttribute('data-parallax-bereit', '');

    var imEditor = window.Shopify && window.Shopify.designMode;
    var eintrag = { sektion: sektion, aufraeumen: function () {} };
    aktiv.push(eintrag);

    /* Die Hoehe der Sektion haengt an --kopf, auch wenn sich nichts bewegt */
    var kopf = 0;
    function kopfMessen() {
      kopf = kopfHoehe();
      sektion.style.setProperty('--kopf', kopf + 'px');
    }
    kopfMessen();

    /* Der Browser bewegt selbst, oder es soll sich nichts bewegen: nur die Kopfzeile nachmessen */
    if (cssScroll || touch.matches || wenigBewegung.matches || imEditor) {
      window.addEventListener('resize', kopfMessen, { passive: true });
      eintrag.aufraeumen = function () {
        window.removeEventListener('resize', kopfMessen);
      };
      return;
    }

    var ebenen = [];
    var liste = sektion.querySelectorAll('[data-parallax-ebene]');
    for (var i = 0; i < liste.length; i++) {
      ebenen.push({ el: liste[i], faktor: parseFloat(window.getComputedStyle(liste[i]).getPropertyValue('--faktor')) || 0 });
    }
    if (!ebenen.length) return;

    var geplant = false;
    var imBlick = true;

    function zeichnen() {
      geplant = false;
      var r = sektion.getBoundingClientRect();
      /* gescrollter Weg: 0 = Sektion steht unter der Kopfzeile, r.height = ganz hinausgescrollt */
      var s = Math.min(r.height, Math.max(0, kopf - r.top));
      for (var j = 0; j < ebenen.length; j++) {
        ebenen[j].el.style.transform = 'translate3d(0,' + (ebenen[j].faktor * s).toFixed(2) + 'px,0)';
      }
    }
    function beiScroll() {
      if (!imBlick || geplant) return;
      geplant = true;
      window.requestAnimationFrame(zeichnen);
    }
    function beiGroesse() {
      kopfMessen();
      beiScroll();
    }

    var beobachter = null;
    if ('IntersectionObserver' in window) {
      beobachter = new IntersectionObserver(function (e) {
        imBlick = e[e.length - 1].isIntersecting;
        if (imBlick) beiScroll();
      });
      beobachter.observe(sektion);
    }
    window.addEventListener('scroll', beiScroll, { passive: true });
    window.addEventListener('resize', beiGroesse, { passive: true });
    zeichnen();

    eintrag.aufraeumen = function () {
      window.removeEventListener('scroll', beiScroll);
      window.removeEventListener('resize', beiGroesse);
      if (beobachter) beobachter.disconnect();
    };
  }

  function start(wurzel) {
    var liste = (wurzel || document).querySelectorAll('[data-parallax]');
    for (var i = 0; i < liste.length; i++) einrichten(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    aktiv = aktiv.filter(function (eintrag) {
      if (!e.target.contains(eintrag.sektion)) return true;
      eintrag.aufraeumen();
      return false;
    });
  });
})();
